module.exports = __webpack_public_path__ + "img/area5_211021.49045749.jpg";